import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IVoiceCallPayload,
  IVoiceCallResponse,
} from "models/setting/voiceCall";
import { voiceCall } from "services/setting";
import { handleSuccessAction, handleErrorAction } from "./voiceCallActions";

function* voiceCallSaga({ payload }: { payload: IVoiceCallPayload }) {
  try {
    const response: IVoiceCallResponse = yield call(voiceCall, payload);
    yield put(handleSuccessAction(response));
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onVoiceCallWatcher() {
  yield takeLatest(ActionType.VOICE_CALL as any, voiceCallSaga);
}

export default [fork(onVoiceCallWatcher)];
